module.exports = __webpack_public_path__ + "static/media/shift_acceptance.12f11d9e.png";